export enum COUNTRIES {
  DE = 'de',
  FR = 'fr',
  NL = 'nl',
  SE = 'se',
  TR = 'tr',
  UK = 'uk',
  US = 'us',
}
